
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoadabasimagicainnova() {



    const cardData =
    {
        keyword: 'Pune to Adlabs Imagica Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Adlabs Imagica Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Adlabs Imagica Innova Crysta Cab Service, delivering a premium, comfortable, and hassle-free journey to the popular amusement park located about 90–93 km from Pune via the Mumbai–Pune Expressway, typically taking 1.5–2 hours . Whether you are planning a fun-filled day with family or friends, our spacious Innova Crysta provides plush leather seating, ample legroom, generous luggage space, and air-conditioning—perfect for the scenic drive through Western Ghats. With door-to-door pickup anywhere in Pune, professional chauffeurs familiar with the route, GPS-enabled vehicles, and flexible one-way or round-trip bookings, Meghana Cab ensures your ride is smooth, reliable, and tailored to your needs. Supported by 24/7 customer assistance and transparent booking, booking your Pune to Adlabs Imagica Innova Crysta Cab with Meghana Cab means enjoying the journey as much as the destination',


        top: ' Top Places to Visit in Imagica with Meghana Cab',

"topPlaces": [
  {
    "title": "Nitro (Floorless Coaster)",
    "description": "India’s tallest floorless coaster—132 ft/65 mph with five inversions. A heart‑racing thrill ride from renowned manufacturer Bolliger & Mabillard, often described as a mix of blockbuster-speed and cinema action."
  },
  {
    "title": "Deep Space",
    "description": "Premier Rides’ indoor launched roller coaster—rocket‑fast, dark‑themed with inversions. A high‑tech sensory blast through space with quick accelerations."
  },
  {
    "title": "Scream Machine",
    "description": "Massive Zamperla Frisbee swing—146 ft tall, spinning riders at steep 120° angles, combining pendulum thrills with rotation for a stomach‑flipping adventure."
  },
  {
    "title": "Mr. India & I for India",
    "description": "Immersive multimedia indoor experiences—‘Mr. India’ is a motion‑simulator based on the iconic Bollywood film, while ‘I for India’ offers an immersive dome‑theatre tour of India’s cultural tapestry."
  },
  {
    "title": "Salimgarh & Wrath of the Gods",
    "description": "Themed dark rides featuring haunted‑fortress adventure and 4D temple‑wrath special effects—laser, water, fire and sound combine for immersive ride‑theatre fun."
  },
  {
    "title": "Alibaba Aur Chalis Chorr",
    "description": "Interactive dark‑ride adventure—shoot laser cannons to outsmart the 40 thieves in a story‑driven, family‑friendly attraction."
  },
  {
    "title": "Rajasaurus River Adventure",
    "description": "Water‑ride safari with animatronic dinosaurs, splashes and mild thrills—fun family escape into a Jurassic-theme river journey."
  },
  {
    "title": "Bump It Boats & Family Rides",
    "description": "Interactive bumper boats, tea‑cup rides, carousel, kids’ driving zone and splash areas—perfect for little ones and family fun."
  },
  {
    "title": "Water & Snow Parks",
    "description": "Aquamagica Water Park (Twin Twister, Thunder Bay, Storm Surge, etc.) and India’s largest indoor Snow Park with edible snow—cool weather fun all year."
  }
],

     "services": [
    {
      "name": "Pune to Adlabs Imagica Innova Crysta Cab Booking",
      "description": "Book a reliable and comfortable Innova Crysta cab for a fun-filled trip from Pune to Adlabs Imagica. Whether you're heading out with friends or family, our spacious vehicle and professional driver ensure a safe and enjoyable ride to India’s favorite theme park."
    },
    {
      "name": "One Way Innova Crysta Pune Imagica",
      "description": "Choose our one-way Innova Crysta cab from Pune to Adlabs Imagica for a convenient drop-off. Perfect for those staying overnight or continuing their journey elsewhere after a day of thrills."
    },
    {
      "name": "Round Trip Innova Crysta Pune Imagica",
      "description": "Enjoy hassle-free travel with our round-trip Innova Crysta service from Pune to Adlabs Imagica and back. Great for same-day theme park visits with a dedicated cab waiting for your return."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Imagica",
      "description": "Beat the heat with our fully air-conditioned Innova Crysta taxi. Travel in comfort from Pune to Adlabs Imagica in a cool and relaxed atmosphere, even during peak summer."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Imagica",
      "description": "Sit back and relax with our chauffeur-driven cab service. Our trained drivers ensure a smooth ride, timely arrival, and courteous service throughout your journey to Imagica."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Imagica",
      "description": "Enjoy complete privacy and comfort with our private Innova Crysta taxi. Ideal for family outings, birthday groups, or special occasions to Adlabs Imagica from Pune."
    },
    {
      "name": "Online Booking Innova Crysta Pune Imagica",
      "description": "Book your cab online in minutes. Get instant confirmation, clear pricing, and the flexibility to choose pickup times that suit your Imagica travel plans."
    },
    {
      "name": "Family Trip Innova Crysta Imagica",
      "description": "Heading to Imagica with the family? Our 6-7 seater Innova Crysta cabs offer spacious interiors, luggage space, and comfort that ensures a stress-free travel experience for kids and adults alike."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Imagica",
      "description": "Experience premium comfort with plush seating, smooth suspension, and ample space in our Innova Crysta cabs—perfect for the hour-long journey to Adlabs Imagica."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Imagica",
      "description": "Travel in style without breaking your budget. Our affordable Innova Crysta cab rates provide luxury at a cost-effective price point for your Imagica visit."
    },
    {
      "name": "Adlabs Imagica Tour Innova Crysta",
      "description": "Make your Imagica day tour smooth and worry-free with our specially curated cab service. We manage pickups, waiting, and returns—so you can focus on the fun."
    },
    {
      "name": "Weekend Trip Innova Crysta Imagica",
      "description": "Planning a weekend getaway to Adlabs Imagica? Our weekend cab packages offer flexibility, convenience, and great pricing for your leisure trip."
    },
    {
      "name": "Reliable Innova Crysta Taxi Imagica",
      "description": "Count on us for dependable service, well-maintained vehicles, and punctual drivers. Make your Imagica visit from Pune safe, reliable, and on-time."
    },
    {
      "name": "Theme Park Trip Innova Crysta Pune",
      "description": "Whether you're visiting Imagica or any nearby amusement destination, our Innova Crysta cabs provide a theme park-ready ride with comfort and convenience."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta vehicles are ideal for long-distance travel like Pune to Imagica. With comfortable features and experienced drivers, your journey will be just as enjoyable as the destination."
    }
  ],
  "tableData": [
    ["Pune to Adlabs Imagica Innova Crysta Cab Booking", "One Way Innova Crysta Pune Imagica"],
    ["Round Trip Innova Crysta Pune Imagica", "AC Innova Crysta Taxi Pune Imagica"],
    ["Chauffeur Driven Innova Crysta Pune Imagica", "Private Innova Crysta Taxi Pune Imagica"],
    ["Online Booking Innova Crysta Pune Imagica", "Family Trip Innova Crysta Imagica"],
    ["Comfortable Innova Crysta Cab Pune Imagica", "Budget Innova Crysta Taxi Pune Imagica"],
    ["Adlabs Imagica Tour Innova Crysta", "Weekend Trip Innova Crysta Imagica"],
    ["Reliable Innova Crysta Taxi Imagica", "Theme Park Trip Innova Crysta Pune"],
    ["Long Distance Innova Crysta Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab from Pune to Adlabs Imagica",
    "WhyChoosedescription": "Enjoy a smooth and luxurious ride from Pune to Adlabs Imagica in our spacious Innova Crysta. Ideal for families and groups heading to the theme park, our cab service ensures a hassle-free and enjoyable start to your day of fun and excitement."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Group Travel",
    "WhyChoosedescription": "The Innova Crysta offers premium seating for up to 6–7 passengers with ample legroom, powerful air conditioning, and generous luggage space—perfect for a comfortable ride to Imagica, especially for families with kids or large groups."
  },
  {
    "WhyChooseheading": "Safe and Experienced Drivers for Leisure Travel",
    "WhyChoosedescription": "Our professional drivers are courteous, punctual, and well-versed with the Pune–Khopoli route. They ensure your journey to Adlabs Imagica is safe, smooth, and stress-free, so you can focus on making memories."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Travel in a thoroughly sanitized and well-maintained Innova Crysta. We maintain top hygiene and service standards to provide a safe and pleasant ride for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Pickup Points Across Pune",
    "WhyChoosedescription": "We offer door-to-door pickup and drop services from anywhere in Pune including Viman Nagar, Hinjewadi, Kothrud, Hadapsar, and more—making your trip to Imagica truly convenient and personalized."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Pune to Adlabs Imagica cab fares include all essential costs like driver allowance, tolls, fuel, and taxes. Get clear pricing upfront and enjoy peace of mind throughout your trip."
  },
  {
    "WhyChooseheading": "Perfect for Theme Park Trips, Family Outings, and Corporate Events",
    "WhyChoosedescription": "Whether you’re planning a family weekend, school trip, birthday outing, or corporate day out at Imagica, our Innova Crysta cabs offer the comfort and convenience needed for a memorable experience."
  },
  {
    "WhyChooseheading": "24/7 Support and Easy Booking Process",
    "WhyChoosedescription": "Book your ride online or via call with round-the-clock customer support. We assist with trip planning, early morning departures, and return drop coordination—ensuring a seamless travel experience to and from Imagica."
  }
]























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Adlabs Imagica?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and convenient booking."
    },
    {
        question: "What is the distance and travel time from Pune to Adlabs Imagica?",
        answer: "Adlabs Imagica is approximately 90 km from Pune, and the journey takes around 2 to 2.5 hours depending on traffic."
    },
    {
        question: "Is Innova Crysta a good option for a family trip to Imagica?",
        answer: "Yes, Innova Crysta is perfect for family and group outings with its spacious seating and comfortable ride."
    },
    {
        question: "Can I book the cab for a round trip on the same day?",
        answer: "Yes, we offer same-day round-trip packages for Pune to Adlabs Imagica."
    },
    {
        question: "Does the fare include tolls and driver charges?",
        answer: "Yes, the fare includes fuel, tolls, and driver charges. Any parking charges at the destination are extra."
    },
    {
        question: "Can I request additional stops for meals or shopping?",
        answer: "Yes, you can request planned stops during your trip. Please inform us while booking."
    },
    {
        question: "Are vehicles sanitized before every trip?",
        answer: "Absolutely. We ensure all cabs are thoroughly sanitized for your safety before every journey."
    },
    {
        question: "Is the driver experienced and familiar with the route to Imagica?",
        answer: "Yes, our drivers are experienced and know the best routes to ensure a smooth ride."
    },
    {
        question: "What if I want to leave Imagica late in the evening?",
        answer: "No problem. Just mention your return time during booking, and we’ll plan accordingly."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Aniket Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Innova Crysta from Pune to Imagica. The cab was super comfortable, and the kids loved the smooth ride.”',
    },
    {
        name: 'Ms. Rutuja Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service by Meghana Cab. Clean vehicle, on-time pickup, and polite driver. Made our Imagica trip easy and fun.”',
    },
];






































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToImagicaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Adlabs Imagica Innova Crysta Cab",
  "description": "Book a chauffeur-driven AC Innova Crysta taxi from Pune to Adlabs Imagica for comfortable family trips, weekend getaways, and theme park tours. One way and round trip options available with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Theme Park Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Adlabs Imagica"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-adlabs-imagica-innova-crysta-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Adlabs Imagica Innova Crysta Cab | Comfortable Theme Park Taxi</title>
  <meta
    name="description"
    content="Chauffeur-driven Innova Crysta cab service from Pune to Adlabs Imagica for family trips and weekend getaways. Book online for one way or round trip AC taxi rides."
  />
  <meta
    name="keywords"
    content="Pune to Adlabs Imagica Innova Crysta Cab Booking, One Way Innova Crysta Pune Imagica, Round Trip Innova Crysta Pune Imagica, AC Innova Crysta Taxi Pune Imagica, Chauffeur Driven Innova Crysta Pune Imagica, Private Innova Crysta Taxi Pune Imagica, Online Booking Innova Crysta Pune Imagica, Family Trip Innova Crysta Imagica, Comfortable Innova Crysta Cab Pune Imagica, Budget Innova Crysta Taxi Pune Imagica, Adlabs Imagica Tour Innova Crysta, Weekend Trip Innova Crysta Imagica, Reliable Innova Crysta Taxi Imagica, Theme Park Trip Innova Crysta Pune, Long Distance Innova Crysta Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToImagicaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoadabasimagicainnova;